const BOOKINGS_LIST_TTL_MS = 60 * 1000;
const INVOICE_TTL_MS = 5 * 60 * 1000;

const bookingsListCache = new Map();
const invoiceCache = new Map();

export const getCachedUserBookings = (userId) => {
  const key = userId != null ? String(userId) : '';
  if (!key) return null;
  const entry = bookingsListCache.get(key);
  if (!entry) return null;
  if (Date.now() - entry.fetchedAt > BOOKINGS_LIST_TTL_MS) {
    bookingsListCache.delete(key);
    return null;
  }
  return entry.bookings;
};

export const setCachedUserBookings = (userId, bookings) => {
  const key = userId != null ? String(userId) : '';
  if (!key) return;
  bookingsListCache.set(key, { bookings, fetchedAt: Date.now() });
};

export const getCachedBookingInvoice = (bookingId) => {
  const key = bookingId != null ? String(bookingId) : '';
  if (!key) return null;
  const entry = invoiceCache.get(key);
  if (!entry) return null;
  if (Date.now() - entry.fetchedAt > INVOICE_TTL_MS) {
    invoiceCache.delete(key);
    return null;
  }
  return entry.meta;
};

export const setCachedBookingInvoice = (bookingId, meta) => {
  const key = bookingId != null ? String(bookingId) : '';
  if (!key) return;
  invoiceCache.set(key, { meta, fetchedAt: Date.now() });
};

export const clearProfileBookingsCache = (userId) => {
  if (userId != null) {
    bookingsListCache.delete(String(userId));
    return;
  }
  bookingsListCache.clear();
  invoiceCache.clear();
};

export const clearBookingInvoiceCache = () => {
  invoiceCache.clear();
};
